var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Close Package Component
 * Allows printing labels, entering weight, and closing a package.
 */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { notification } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { PrinterOutlined } from '@ant-design/icons';
import Input from '@fp-suite/core-ui/src/components/Input';
import Button from '@fp-suite/core-ui/src/components/Button';
import Dropdown from '@fp-suite/core-ui/src/components/Dropdown';
import { usePackingState, usePackingActions, useLabelPrinting } from '../../../hooks/packing';
import { selectSpsCartonLabel, selectShipmentData } from '../../../redux/packing';
export var ClosePackage = function (_a) {
    var _b, _c, _d;
    var packageSeqId = _a.packageSeqId, onClosed = _a.onClosed;
    var t = useTranslation().t;
    var _e = usePackingState(), shipmentId = _e.shipmentId, packageMetadataBySeqId = _e.packageMetadataBySeqId, boxTypes = _e.boxTypes, loadBoxTypes = _e.loadBoxTypes, loading = _e.loading, loadPackageWeight = _e.loadPackageWeight;
    var handleClosePackage = usePackingActions().handleClosePackage;
    var _f = useLabelPrinting(), printPackingSlip = _f.printPackingSlip, printMainLabel = _f.printMainLabel, printCartonLabel = _f.printCartonLabel;
    var spsCartonLabel = useSelector(selectSpsCartonLabel);
    var shipmentData = useSelector(selectShipmentData);
    var _g = useState(''), weight = _g[0], setWeight = _g[1];
    var _h = useState(undefined), selectedBoxType = _h[0], setSelectedBoxType = _h[1];
    var weightInputRef = useRef(null);
    // Resolve box type from metadata or fallback to selected
    var metadataBoxTypeId = (_c = (_b = packageMetadataBySeqId === null || packageMetadataBySeqId === void 0 ? void 0 : packageMetadataBySeqId[packageSeqId]) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.shipmentBoxTypeId;
    var shipmentBoxTypeId = metadataBoxTypeId || selectedBoxType;
    var needsBoxTypeSelection = !metadataBoxTypeId;
    // Load box types if needed
    useEffect(function () {
        if (needsBoxTypeSelection && (!boxTypes || boxTypes.length === 0)) {
            loadBoxTypes();
        }
    }, [needsBoxTypeSelection, boxTypes, loadBoxTypes]);
    // Auto-populate weight from scale on mount
    useEffect(function () {
        if (shipmentId) {
            loadPackageWeight(shipmentId, packageSeqId).then(function (result) {
                if (result !== null) {
                    setWeight(String(result));
                }
            });
        }
    }, [shipmentId, packageSeqId, loadPackageWeight]);
    // Focus weight input on mount
    useEffect(function () {
        var _a;
        (_a = weightInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    var canSubmit = !!weight && !!shipmentBoxTypeId;
    var handleSubmit = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!canSubmit || !shipmentBoxTypeId)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, handleClosePackage({
                            shipmentPackageSeqId: packageSeqId,
                            shipmentBoxTypeId: shipmentBoxTypeId,
                            weight: parseFloat(weight),
                            weightUomId: 'WT_lb'
                        })];
                case 2:
                    _a.sent();
                    onClosed();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    notification.error({
                        message: t('Error'),
                        description: t('Failed to close package')
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [canSubmit, shipmentBoxTypeId, packageSeqId, weight, handleClosePackage, onClosed, t]);
    var handleWeightKeyDown = useCallback(function (e) {
        if (e.key === 'Enter') {
            handleSubmit();
        }
    }, [handleSubmit]);
    var productStoreId = (_d = shipmentData === null || shipmentData === void 0 ? void 0 : shipmentData.shipment) === null || _d === void 0 ? void 0 : _d.productStoreId;
    return (_jsxs("div", __assign({ className: 'space-y-5' }, { children: [_jsxs("h2", __assign({ className: 'text-lg font-bold text-gray-800' }, { children: [t('Closing Package'), " ", _jsx("span", __assign({ className: 'text-primary' }, { children: packageSeqId }), void 0)] }), void 0), _jsxs("div", __assign({ className: 'bg-white rounded-xl border border-blue-100 shadow-sm p-4' }, { children: [_jsx("h3", __assign({ className: 'text-sm font-bold text-gray-600 mb-3' }, { children: t('Print Labels') }), void 0), _jsxs("div", __assign({ className: 'flex flex-wrap gap-2' }, { children: [_jsx(Button, { buttonText: _jsxs("div", __assign({ className: 'flex items-center' }, { children: [_jsx(PrinterOutlined, { className: 'mr-1.5', style: { fontSize: 16 } }, void 0), t('Packing Slip')] }), void 0), paddingX: 'px-4', paddingY: 'py-2.5', onClick: function () { return printPackingSlip(); }, defaultColor: 'bg-primary', classNames: 'rounded-lg text-sm' }, void 0), _jsx(Button, { buttonText: _jsxs("div", __assign({ className: 'flex items-center' }, { children: [_jsx(PrinterOutlined, { className: 'mr-1.5', style: { fontSize: 16 } }, void 0), t('Shipping Label')] }), void 0), paddingX: 'px-4', paddingY: 'py-2.5', onClick: function () { return printMainLabel(packageSeqId); }, defaultColor: 'bg-primary', classNames: 'rounded-lg text-sm' }, void 0), spsCartonLabel === true && productStoreId && (_jsx(Button, { buttonText: _jsxs("div", __assign({ className: 'flex items-center' }, { children: [_jsx(PrinterOutlined, { className: 'mr-1.5', style: { fontSize: 16 } }, void 0), t('License Plate')] }), void 0), paddingX: 'px-4', paddingY: 'py-2.5', onClick: function () { return printCartonLabel(productStoreId); }, defaultColor: 'bg-primary', classNames: 'rounded-lg text-sm' }, void 0))] }), void 0)] }), void 0), _jsxs("div", __assign({ className: 'bg-white rounded-xl border border-blue-100 shadow-sm p-4 space-y-4' }, { children: [needsBoxTypeSelection && (_jsxs("div", { children: [_jsx("h3", __assign({ className: 'font-bold text-sm text-gray-600 mb-1.5' }, { children: t('Box Type') }), void 0), _jsx(Dropdown, { searchable: true, placeholder: t('Select Box Type'), data: boxTypes, value: selectedBoxType, onChange: function (val) { return setSelectedBoxType(val); } }, void 0)] }, void 0)), _jsxs("div", { children: [_jsx("h3", __assign({ className: 'font-bold text-sm text-gray-600 mb-1.5' }, { children: t('Package Weight') }), void 0), _jsxs("div", __assign({ className: 'flex items-center gap-2' }, { children: [_jsx("div", __assign({ className: 'flex-1' }, { children: _jsx(Input, { ref: weightInputRef, inputType: 'number', title: '', placeholder: t('Scan weight'), value: weight, onChange: function (e) { return setWeight(e.target.value); }, onKeyDown: handleWeightKeyDown }, void 0) }), void 0), _jsx("span", __assign({ className: 'text-sm font-semibold text-gray-500' }, { children: "lbs" }), void 0)] }), void 0)] }, void 0), _jsx(Button, { buttonText: t('Close Package'), paddingX: 'px-6', paddingY: 'py-3', onClick: handleSubmit, loading: loading.closePackage, isDisabled: !canSubmit, defaultColor: 'bg-green-600', classNames: 'rounded-lg text-sm w-full', widthFull: true }, void 0)] }), void 0)] }), void 0));
};
export default ClosePackage;
